module.exports = __webpack_public_path__ + "img/day.da8b9027.jpg";